import { combineReducers } from "redux";
import information from "./get-expert-information";
import groups from "./get-expert-groups";
import expertExist from "./validate-expert-username";
import linkGateway from "./link-gateways";

const reducer = combineReducers({
  information,
  groups,
  expertExist,
  linkGateway
});

export default reducer;
